var map = {
	"./arrow.svg": "315f",
	"./camera.svg": "8a64",
	"./cancel_full.svg": "a896",
	"./cancel_mic_mute.svg": "831c",
	"./copy.svg": "5e82",
	"./end_call.svg": "e36d",
	"./full.svg": "73b2",
	"./hand_down.svg": "0fdf",
	"./hand_end.svg": "c910",
	"./hand_up.svg": "c4cf",
	"./hang_up.svg": "bedc",
	"./hang_up_full.svg": "8b06",
	"./home.svg": "dfed",
	"./icon_device_message.svg": "cbe9",
	"./icon_device_volume.svg": "5332",
	"./icon_mic.svg": "0b6f",
	"./icon_play.svg": "47d5",
	"./layout.svg": "ca4f",
	"./meeting_host.svg": "1aef",
	"./mic_mute.svg": "bbda",
	"./mic_null.svg": "87f1",
	"./more.svg": "d9cb",
	"./mute_camera.svg": "ad1c",
	"./mute_camera_error.svg": "3ce8",
	"./mute_mic_error.svg": "81cc",
	"./next.svg": "95b9",
	"./previous.svg": "f3d9",
	"./rotate.svg": "3f1b",
	"./setting.svg": "1d1a",
	"./share.svg": "40eb",
	"./share_stop.svg": "7b60",
	"./signal.svg": "fdf9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3bff";